import React from 'react';
import { Modal, Button } from 'antd';
import _ from 'lodash';

export const showError = (error, title = null) => {
  let message = '';
  if(error instanceof String) {
    message = error;
  }else{
    message = (_.has(error, 'response.body.error')) ? error.response.body.error : error.message;
  }
  if(title == null){
    title = 'エラーが発生しました';
  }
  console.error(error);

  if(message == "Your card's security code is incorrect."){
    message = "有効期限、CVC番号の入力を再度ご確認ください。\n" +
      "クレジットカードが利用上限などの理由でご利用できない場合は、カード会社へお問い合わせください。";
  }else if(message == "Your card was declined."){

  }

  let secondsToGo = 5;
  const modal = Modal.error({
    title: title,
    content: message,
  });

  return message;
  /*
  const timer = setInterval(() => {
    secondsToGo -= 1;
  }, 1000);
  setTimeout(() => {
    clearInterval(timer);
    modal.destroy();
  }, secondsToGo * 1000);
    */
};


/**
 * Price Component
 * @param item
 * @param jpy
 * @returns {*}
 * @constructor
 */
export const Price = ({item, jpy}) => (
  <div className='tour-price'>
    <div className='font-weight-bold fs-xs mb-0'>
      <span className='mr-1 aud'>豪ドル</span>
      {item.original &&
      <span className='card-travel__before before'>${item.original}</span>
      }
      <span className='text-success h3 font-weight-bold ml-1 now'>${item.price}</span>
    </div>
    {jpy &&
    <div className='font-weight-bold fs-xs mb-0'>
      {item.price &&
      <span className='dimio-jpy'> (約{parseInt(item.price) * parseInt(jpy)}円)</span>
      }
    </div>
    }
  </div>
);

export const mapStateToProps = (state, ownProps) => {
  const {core} = state;

  let ret = {core: core};

  if(core.model) {
    /*
    if(ownProps.model!== undefined && state[ownProps.model]) {
      ret[ownProps.model] = state[ownProps.model];
    }
    */
    ret[core.model] = state[core.model];
  }

  console.info('Loaded Models:', ret);
  return ret;
}




// WEBPACK FOOTER //
// ./src/lib/Common.js